var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBookingsYet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.814 134.993C190.814 134.993 213.897 110.568 206.56 68.0681C199.222 25.5685 161.527 9.91025 136.528 18.0903C111.529 26.2703 105.89 40.5078 85.4724 48.6495C65.0547 56.7913 26.2571 51.2018 6.85602 78.5494C-12.545 105.897 12.2236 151.213 43.756 179.628C75.2884 208.043 155.753 190.254 190.814 134.993Z",
    fill: "#ECEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30778_75641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.693 22.6997L176.306 35.5297L146.756 33.4795L140.693 22.6997Z",
    fill: "#63C7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.306 35.5297L155.691 52.1619L149.152 37.7862L176.306 35.5297Z",
    fill: "#63C7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.756 33.4795L142.155 43.3808L149.153 37.7862L176.306 35.5297L146.756 33.4795Z",
    fill: "#6B767B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.154 43.3808L151.696 43.3795L149.152 37.7862L142.154 43.3808Z",
    fill: "#CAEDFB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.83 184.66C105.83 183.88 105.2 183.25 104.42 183.25C103.64 183.25 103.01 183.88 103.01 184.66C103.01 185.44 103.64 186.07 104.42 186.07C105.2 186.07 105.83 185.44 105.83 184.66Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.36 184.661C105.36 184.141 104.94 183.721 104.42 183.721C103.9 183.721 103.48 184.141 103.48 184.661C103.48 185.181 103.9 185.601 104.42 185.601C104.94 185.601 105.36 185.181 105.36 184.661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2398 122.391H117.25C119.64 122.391 121.59 124.341 121.59 126.731C121.59 129.121 119.63 131.081 117.25 131.081H92.2398C89.8498 131.081 87.8998 129.131 87.8998 126.741C87.8998 124.351 89.8498 122.401 92.2398 122.401V122.391ZM60.0098 117.191H149.48V164.841H60.0098V117.191Z",
    fill: "#CAEDFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2398 122.391H117.25C119.64 122.391 121.59 124.341 121.59 126.731C121.59 129.121 119.63 131.071 117.25 131.071H92.2398C89.8498 131.071 87.8998 129.121 87.8998 126.731C87.8998 124.341 89.8498 122.391 92.2398 122.391ZM60.0098 117.191H149.48V164.841H60.0098V117.191Z",
    stroke: "#6B767B",
    strokeWidth: 1.11,
    strokeMiterlimit: 22.93
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.48 117.191L171.85 135.671V135.721H149.48V117.191Z",
    fill: "#6B767B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.48 117.191L171.85 135.671V135.721H149.48V117.191Z",
    stroke: "#6B767B",
    strokeWidth: 1.11,
    strokeMiterlimit: 22.93
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.01 117.191L37 135.671V135.721H60.01V117.191Z",
    fill: "#6B767B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.01 117.191L37 135.671V135.721H60.01V117.191Z",
    stroke: "#6B767B",
    strokeWidth: 1.11,
    strokeMiterlimit: 22.93
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.41 145.421H121.43C124.68 145.421 127.34 148.081 127.34 151.331C127.34 154.581 124.68 157.241 121.43 157.241H87.41C84.16 157.241 81.5 154.581 81.5 151.331C81.5 148.081 84.16 145.421 87.41 145.421ZM37 135.721H171.84V181.801C171.84 184.051 170 185.891 167.75 185.891H41.09C38.84 185.891 37 184.051 37 181.801V135.721Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.41 145.421H121.43C124.68 145.421 127.34 148.081 127.34 151.331C127.34 154.581 124.68 157.241 121.43 157.241H87.41C84.16 157.241 81.5 154.581 81.5 151.331C81.5 148.081 84.16 145.421 87.41 145.421ZM37 135.721H171.84V181.801C171.84 184.051 170 185.891 167.75 185.891H41.09C38.84 185.891 37 184.051 37 181.801V135.721Z",
    stroke: "#6B767B",
    strokeWidth: 1.11,
    strokeMiterlimit: 22.93
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7497 55.6309C63.7897 62.7909 58.6797 59.3509 69.0697 65.9509C58.2097 60.1609 63.7197 62.9109 52.5397 57.7109C51.9697 57.3809 51.7697 56.6409 52.1097 56.0709C52.4397 55.5009 53.1797 55.3009 53.7497 55.6409",
    fill: "#63C7EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.45 111.891C91.96 100.081 75.06 79.1609 100.7 66.2909C109.71 61.7709 115.57 71.7609 112.92 77.3609C110.62 82.2309 92.56 84.2209 98.28 68.0409C106.27 45.4409 123.34 37.6409 137.06 39.8909",
    stroke: "#63C7EF",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.8 4.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6106 46.1408C75.0706 56.1108 74.1806 51.1608 76.2906 60.9908C73.2706 51.4008 74.9406 56.1508 71.2906 46.7508C71.1206 46.1108 71.5005 45.4508 72.1405 45.2808C72.7805 45.1108 73.4406 45.4908 73.6106 46.1308",
    fill: "#63C7EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1696 79.5409C63.1296 77.9709 58.1896 78.9209 67.9896 76.7109C58.4296 79.8309 63.1596 78.1109 53.8096 81.8609C53.1696 82.0409 52.5096 81.6609 52.3396 81.0209C52.1596 80.3809 52.5396 79.7209 53.1796 79.5509",
    fill: "#63C7EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.469 88.3412C145.839 84.2612 151.699 86.1412 139.879 82.7012C151.919 85.2312 145.869 84.1312 158.049 86.0112C158.689 86.1712 159.079 86.8212 158.919 87.4612C158.759 88.1012 158.109 88.4912 157.469 88.3312",
    fill: "#63C7EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.69 67.4113C142.52 71.5913 147.02 69.3513 138.17 74.1113C146.54 68.5513 142.45 71.4713 150.46 65.3513C151.03 65.0113 151.76 65.1913 152.11 65.7613C152.45 66.3313 152.27 67.0713 151.7 67.4113",
    fill: "#63C7EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.701 104.75C135.621 95.5402 137.801 100.07 133.141 91.1602C138.621 99.5902 135.741 95.4602 141.771 103.54C142.101 104.11 141.911 104.85 141.341 105.18C140.771 105.51 140.031 105.32 139.701 104.75Z",
    fill: "#63C7EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30778_75641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.8596,
    height: 25.1724,
    fill: "white",
    transform: "translate(145.383 15.4698) rotate(32.9716)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBookingsYet);
export default __webpack_public_path__ + "static/media/no-bookings-yet.ab9bd36a6eae420a3c708f15ecc0ec2b.svg";
export { ForwardRef as ReactComponent };